module.exports = __webpack_public_path__ + "img/card.0bb56bd9.svg";